import { render, staticRenderFns } from "./UploadMedicalFiles.vue?vue&type=template&id=5f5f1f2a&"
import script from "./UploadMedicalFiles.vue?vue&type=script&lang=js&"
export * from "./UploadMedicalFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports